<!-- RAW JSON INPUT -->
<div class="editor">
  <mat-card-subtitle>Overview JSON Input</mat-card-subtitle>

  <textarea rows="10" style="width:100%" [(ngModel)]="jsonInputText" name="jsonInputText">
  </textarea>

  <button mat-raised-button color="primary" type="button" (click)="loadJson()" class="load-overview-button">
    Load Overview
  </button>
  @if (parseError) {

    <div style="color:red;">
      {{ parseError }}
    </div>
  }
  <button mat-raised-button color="accent" (click)="applyChanges()" [disabled]="!showEditor">
    Apply Changes
  </button>
  <button mat-raised-button type="button" (click)="showOverview()">
    Show Overview Final Look
  </button>
</div>

<div class="structured-editor">
  <mat-form-field appearance="outline" class="title">
    <mat-label>Title</mat-label>
    <input matInput [(ngModel)]="overviewData.title" name="title">
  </mat-form-field>

  <mat-form-field appearance="outline" class="title">
    <mat-label>Subtitle</mat-label>
    <input matInput [(ngModel)]="overviewData.subtitle" name="subtitle">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Description</mat-label>
    <textarea matInput [(ngModel)]="overviewData.description" name="description"></textarea>
  </mat-form-field>

</div>

<!-- STRUCTURED EDITOR -->
@if (showEditor) {
  <div class="structured-editor">


    <div>
      @for (section of content; let i = $index; track i) {
        <hr>
        <mat-card-title>New Section</mat-card-title>
        <mat-form-field appearance="outline" class="title">
          <mat-label>Title</mat-label>
          <input matInput [(ngModel)]="section.title" [name]="'section_title_' + i" required>
        </mat-form-field>
        <div>
          <mat-form-field appearance="outline">
            <mat-label>Description</mat-label>
            <textarea matInput [(ngModel)]="section.description" name="description"></textarea>
          </mat-form-field>
          <mat-card>
            <mat-card-subtitle>Create bulletpoints</mat-card-subtitle>
            @for (item of section.itemList; let j = $index; track j) {
              <div class="item">
                &#x2022;
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Bulletpoint {{ j + 1 }}</mat-label>
                  <input matInput [(ngModel)]="section.itemList[j]" [name]="'item_' + i + '_' + j">
                </mat-form-field>
                <button mat-icon-button color="warn" type="button"
                        (click)="removeItem(i, j)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
            <button mat-raised-button color="primary" (click)="addItem(i)" type="button">
              <mat-icon>add</mat-icon>
              Bulletpoint
            </button>

          </mat-card>
          <mat-card>
            <mat-card-subtitle>Create a table</mat-card-subtitle>
            <span class="horizontal-scroll">
            @for (item of section.tableRows; let j = $index; track j) {
              <div class="item">
                @for (cell of section.tableRows[j]; let k = $index; track k) {
                  <div class="first-table-row">

                    @if (j === 0) {
                      <button mat-icon-button color="warn" type="button"
                              (click)="removeColumn(i, k)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    }
                    <mat-form-field appearance="outline" class="table-cell-input" subscriptSizing="dynamic">
                      <mat-label>Row {{ j + 1 }}, cell {{ k + 1 }}</mat-label>
                      <input matInput [(ngModel)]="section.tableRows[j][k]" [name]="'row_' + i + '_' + j">
                    </mat-form-field>
                  </div>
                }
                <button mat-icon-button color="warn" type="button"
                        (click)="removeRow(i, j)">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }

            </span>
            <div>
              <button mat-raised-button color="primary" (click)="addTableRow(i)" type="button">
                <mat-icon>add</mat-icon>
                Table Row ≡
              </button>
              <button mat-raised-button color="primary" (click)="addTableColumn(i)" type="button">
                <mat-icon>add</mat-icon>
                Table Column 〣
              </button>
            </div>
          </mat-card>
          <mat-card>
            <mat-card-subtitle>Create a note</mat-card-subtitle>
            <mat-form-field appearance="outline" class="notes">
              <mat-label>Note</mat-label>
              <textarea matInput [(ngModel)]="section.notes" [name]="'section_notes_' + i"></textarea>
            </mat-form-field>

          </mat-card>
        </div>
      }

    </div>

  </div>
}

<button mat-raised-button color="primary" (click)="addNewSection()" type="button">
  <mat-icon>add</mat-icon>
  New Section
</button>
